export default __webpack_public_path__ + "static/green_frog_desktop-0b7bd1dde882bc16f4da5e705597e40c.png";